import React from 'react';

export function SettingsPage() {
  return (
    <div>
      <p>You are in Settings</p>
    </div>
  );
}
